import "./editor-context-Cci4uqN_.js";
import { createComponent } from "./create-component-CBvs05W1.js";
import { autocompleteEmptyEvents, autocompleteEmptyProps, autocompleteItemEvents, autocompleteItemProps, autocompleteListEvents, autocompleteListProps, autocompletePopoverEvents, autocompletePopoverProps } from "@prosekit/web/autocomplete";

//#region src/components/autocomplete/autocomplete-empty.gen.ts
const AutocompleteEmpty = createComponent("prosekit-autocomplete-empty", "AutocompleteEmpty", Object.keys(autocompleteEmptyProps), Object.keys(autocompleteEmptyEvents));

//#endregion
//#region src/components/autocomplete/autocomplete-item.gen.ts
const AutocompleteItem = createComponent("prosekit-autocomplete-item", "AutocompleteItem", Object.keys(autocompleteItemProps), Object.keys(autocompleteItemEvents));

//#endregion
//#region src/components/autocomplete/autocomplete-list.gen.ts
const AutocompleteList = createComponent("prosekit-autocomplete-list", "AutocompleteList", Object.keys(autocompleteListProps), Object.keys(autocompleteListEvents));

//#endregion
//#region src/components/autocomplete/autocomplete-popover.gen.ts
const AutocompletePopover = createComponent("prosekit-autocomplete-popover", "AutocompletePopover", Object.keys(autocompletePopoverProps), Object.keys(autocompletePopoverEvents));

//#endregion
export { AutocompleteEmpty, AutocompleteItem, AutocompleteList, AutocompletePopover };